
const defaultBaseSettings = {
    alarms: {
        alarmColors: {
            selected: {
                new: { background: '#0080ff', foreground: '#ffffff' },
                acked: { background: '#0080ff', foreground: '#ffffff' },
                cleared: { background: '#0080ff', foreground: '#ffffff' }
            },
            observational: {
                new: { background: '#000000', foreground: '#ffffff' },
                acked: { background: '#000000', foreground: '#ffffff' },
                cleared: { background: '#000000', foreground: '#ffffff' }
            },
            minor: {
                new: { background: '#ffff00', foreground: '#000000' },
                acked: { background: '#ffff00', foreground: '#000000' },
                cleared: { background: '#ffff00', foreground: '#000000' }
            },
            major: {
                new: { background: '#ff0000', foreground: '#ffffff' },
                acked: { background: '#ff0000', foreground: '#ffffff' },
                cleared: { background: '#ff0000', foreground: '#ffffff' }
            },
            critical: {
                new: { background: '#ff00ff', foreground: '#ffffff' },
                acked: { background: '#ff00ff', foreground: '#ffffff' },
                cleared: { background: '#ff00ff', foreground: '#ffffff' }
            },
            geographical: {
                critical: { background: '#ff00ff', foreground: '#ffffff' },
                major: { background: '#ff0000', foreground: '#ffffff' },
                minor: { background: '#ffff00', foreground: '#000000' },
                observational: { background: '#000000', foreground: '#ffffff' },
                normal: { background: '#70DA70', foreground: '#ffffff' },
            }
        },

        alarmSnackbar: {
            alarmSnackbarEnabled: false,
            alarmSnackbarCriticalEnabled: true,
            alarmSnackbarMajorEnabled: true,
            alarmSnackbarMinorEnabled: true,
            alarmSnackbarObservationalEnabled: true,
            alarmSnackbarTimeout: 5000
        },

        pagingEmailTemplate: null
    },

    issues: {
        issuesColors: {
            useAlarmColors: true,
            selected: {
                new: { background: '#0080ff', foreground: '#ffffff' },
                acked: { background: '#0080ff', foreground: '#ffffff' },
                cleared: { background: '#0080ff', foreground: '#ffffff' }
            },
            observational: {
                new: { background: '#000000', foreground: '#ffffff' },
                acked: { background: '#000000', foreground: '#ffffff' },
                cleared: { background: '#000000', foreground: '#ffffff' }
            },
            minor: {
                new: { background: '#ffff00', foreground: '#000000' },
                acked: { background: '#ffff00', foreground: '#000000' },
                cleared: { background: '#ffff00', foreground: '#000000' }
            },
            major: {
                new: { background: '#ff0000', foreground: '#ffffff' },
                acked: { background: '#ff0000', foreground: '#ffffff' },
                cleared: { background: '#ff0000', foreground: '#ffffff' }
            },
            critical: {
                new: { background: '#ff00ff', foreground: '#ffffff' },
                acked: { background: '#ff00ff', foreground: '#ffffff' },
                cleared: { background: '#ff00ff', foreground: '#ffffff' }
            }
        },
    },
    

    sounds: {
        criticalAlarmSound: null,
        criticalAlarmSoundActive: false,
        majorAlarmSound: null,
        majorAlarmSoundActive: false,
        minorAlarmSound: null,
        minorAlarmSoundActive: false,
        observationalAlarmSound: null,
        observationalAlarmSoundActive: false,
        broadcastSound: null,
        broadcastSoundActive: false,
        newChatMessageSound: null,
        newChatMessageSoundActive: false,
    },


    preferences: {
        startPage: null,
        thinScrollbar: false,
        inactivityTimeoutMin: 240 // 4 hrs
    },

    reports: {
        defaultDensity: 'comfortable',
        autosizeColumns: false,
        defaultChartAllColumns: false,
        convertToPercentForExport: false,
        chartColors: ["#f7a35c", "#7cb5ec", "#278713", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
        allowRightClickEditChartColors: false,
        metricCommonColor: false
    }
};



export { defaultBaseSettings };